import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  ChatCircleText, FileText, CheckCircle, CreditCard, Truck, MapPin, Package,
} from "@phosphor-icons/react";

const steps = [
  { icon: ChatCircleText, t: "Request Fuel", d: "Tell us your fuel type, quantity and delivery location — online or by WhatsApp." },
  { icon: FileText, t: "Receive Your Quote", d: "We confirm the agreed price per litre, delivery and any charges, then email your quotation." },
  { icon: CheckCircle, t: "Accept Quote", d: "Review and accept the quotation from your phone in one tap." },
  { icon: CreditCard, t: "Pay Required Amount", d: "Pay in full or the agreed deposit. Payment releases your delivery." },
  { icon: Truck, t: "Dispatch", d: "Once payment is confirmed, your order is scheduled and dispatched." },
  { icon: MapPin, t: "Track & Confirm Delivery", d: "Follow progress on a simple timeline and confirm safe delivery." },
];

export default function HowItWorks() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-16">
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">How Delivery Works</h1>
      <p className="mt-3 text-lg text-slate-600 max-w-2xl">
        A clear, professional process where payment is part of what releases your delivery — not an afterthought.
      </p>

      <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {steps.map((s, i) => (
          <div key={s.t} className="relative border border-[#E5E7EB] rounded-lg bg-white p-6">
            <div className="flex items-center justify-between">
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-[#0A4F35]/10 text-[#0A4F35]">
                <s.icon size={26} />
              </div>
              <span className="font-display text-4xl font-extrabold text-slate-100">{i + 1}</span>
            </div>
            <h3 className="mt-4 font-display text-lg font-bold text-slate-900">{s.t}</h3>
            <p className="mt-2 text-sm text-slate-600">{s.d}</p>
          </div>
        ))}
      </div>

      <div className="mt-14 rounded-lg bg-[#0A4F35] px-6 sm:px-10 py-10 text-white flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div>
          <h2 className="font-display text-2xl font-bold">Ready to place an order?</h2>
          <p className="mt-2 text-emerald-100/80 max-w-lg">Start with a quick request — no account required. Fast turnaround once your payment clears.</p>
        </div>
        <Link to="/request-fuel">
          <Button className="h-12 px-7 bg-[#E5B800] hover:bg-[#CCA300] text-black font-bold">Request Fuel Delivery</Button>
        </Link>
      </div>
    </div>
  );
}
